import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ViyaCrab = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 min-h-[60vh] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://customer-assets.emergentagent.com/job_mea-connect/artifacts/2sjns3a5_3246B146-8E02-4193-AF88-7EFC489BF711.jpeg"
            alt="VIYA CRAB Premium Crab Meat"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#003840]/65 via-[#003840]/55 to-[#003840]/65"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 animate-float">
              {t.viyaCrab.title}
            </h1>
            <p className="text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed animate-fade-in">
              {t.viyaCrab.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Featured Client - VIYA CRAB */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-5xl mx-auto text-center">
              {t.viyaCrab.featuredClient.description}
            </p>
          </div>

          {/* Products Grid */}
          <div className="mb-16">
            <h4 className="text-2xl font-bold text-[#003840] mb-8 text-center">{t.viyaCrab.productsTitle}</h4>
            <div className="grid md:grid-cols-3 gap-8">
              {/* Colossal Lump */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/srqwgwx5_Colossal%20lump%2002.JPEG"
                    alt="Colossal Lump"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[0]}</h5>
                </div>
              </div>

              {/* Jumbo Lump */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/gf1cwc05_Jumbo%20Lump%20copy.JPEG"
                    alt="Jumbo Lump"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[1]}</h5>
                </div>
              </div>

              {/* Super Lump */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/t1scd8cq_Super%20lump%202.jpeg"
                    alt="Super Lump"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[2]}</h5>
                </div>
              </div>

              {/* Backfin Lump */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/n6v4h0pu_Backfin%20Lump%2001.JPEG"
                    alt="Backfin Lump"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[3]}</h5>
                </div>
              </div>

              {/* Special */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/1iam1hw2_Special%2001.JPEG"
                    alt="Special"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[4]}</h5>
                </div>
              </div>

              {/* Claw Meat */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-64 overflow-hidden">
                  <img
                    src="https://customer-assets.emergentagent.com/job_aria-trading/artifacts/mbrdpzku_Claw%2001.JPEG"
                    alt="Claw Meat"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h5 className="text-lg font-bold text-[#003840] leading-tight">{t.viyaCrab.featuredClient.features[5]}</h5>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#003840] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t.cta.distribution.title}
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            {t.cta.distribution.subtitle}
          </p>
        </div>
      </section>
    </div>
  );
};

export default ViyaCrab;
